var map = {
	"./events-cat.webp": 2095,
	"./games-cat.webp": 2096,
	"./live-casino-cat.webp": 2097,
	"./lottery-cat.webp": 2098,
	"./other-cat.webp": 2099,
	"./p2p-cat.webp": 2100,
	"./pd-table.webp": 2101,
	"./privacy-policy-title-bm.webp": 2102,
	"./privacy-policy-title-cn.webp": 2103,
	"./privacy-policy-title-id.webp": 2104,
	"./privacy-policy-title.webp": 2105,
	"./promos-1.webp": 2106,
	"./promos-2.webp": 2107,
	"./promos-3.webp": 2108,
	"./promos-4.webp": 2109,
	"./question.webp": 2110,
	"./sideBar-bg.webp": 2111,
	"./slot-cat.webp": 2112,
	"./special-cat.webp": 2113,
	"./sports-cat.webp": 2114
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 482;